export const inputQuestions = [
  {
    name: 'id',
    type: 'hidden',
  },
  {
    label: 'Pregunta',
    type: 'text',
    name: 'question_text',
    placeholder: 'Pregunta',
    colSize: 8,
  },
  {
    label: 'Tipo de Pregunta',
    type: 'choosen',
    name: 'type_question_id',
    placeholder: 'Tipo de Pregunta',
    colSize: 3,
  },
  {
    label: 'Requerida',
    type: 'checkbox',
    name: 'is_required',
    colSize: 1,
  },
  {
    label: '',
    type: 'hidden',
    name: 'key_type_question',
    placeholder: '',
    colSize: 0,
  },
]

export const inputOptions = [
  {
    name: 'id',
    type: 'hidden',
  },
  // {
  //   label: 'Orden',
  //   type: 'text',
  //   name: 'order',
  //   placeholder: 'Orden',
  //   colSize: 3,
  // },
  {
    label: 'Opción',
    type: 'text',
    name: 'option_text',
    placeholder: 'Opción',
    colSize: 3,
  },
  {
    label: '',
    type: 'hidden',
    name: 'question_id',
    placeholder: '',
    colSize: 0,
  },
  // {
  //   label: 'Valor',
  //   type: 'text',
  //   name: 'option_value',
  //   placeholder: 'Valor',
  //   colSize: 12,
  // },
]
